import { fetchMedications } from '@/services/medications'
import { FETCH_MEDICATIONS } from '@/store/medications/index.js'

const getMedications = (params) => async (dispatch) => {
  let { medicamentos, pageInfo } = await fetchMedications(params)
  dispatch(FETCH_MEDICATIONS({ medicamentos, pageInfo }))
}

export { getMedications }
